import { ArrowDown, MessageCircle, Palette, Shield, Sparkles } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const stats = [
  { value: "6", label: "Pilihan Warna" },
  { value: "3", label: "Ketebalan" },
  { value: "122 x 244", label: "Ukuran Standar" },
];

export const ProductPageHero = () => {
  return (
    <section
      id="produk-detail"
      data-testid="product-page-hero"
      className="relative min-h-screen pt-36 pb-24 bg-animax-black text-white overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={PHOTOS.produksiRak}
          alt="Animax Acrylic Sheet"
          className="w-full h-full object-cover opacity-65"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-animax-black via-animax-black/68 to-animax-black/15" />
        <div className="absolute inset-0 bg-gradient-to-t from-animax-black via-transparent to-animax-black/45" />
        <div className="absolute inset-0 bg-animax-yellow/5" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/10 backdrop-blur-md mb-6">
              <Sparkles className="w-4 h-4 text-animax-yellow" />
              <span className="tag-uppercase text-white/80">ANIMAX Acrylic</span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tighter font-medium">
              Acrylic Sheet untuk kebutuhan signage, display, dan proyek
            </h1>
            <p className="mt-6 text-base sm:text-lg text-white/70 leading-relaxed max-w-2xl">
              Halaman produk dari PT APL untuk melihat katalog warna, ukuran, ketebalan, teknologi
              perlindungan UV, dan rekomendasi penggunaan ANIMAX Acrylic Sheet secara lebih detail.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#produk"
                data-testid="product-hero-catalog"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-animax-yellow text-animax-black font-medium text-sm hover:bg-animax-orange hover:text-white transition-all"
              >
                <Palette className="w-4 h-4" />
                Lihat Katalog Warna
                <ArrowDown className="w-4 h-4" />
              </a>
              <a
                href="#tim-sales"
                data-testid="product-hero-sales"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white hover:text-animax-black transition-all"
              >
                <MessageCircle className="w-4 h-4" />
                Tanya Stok & Harga
              </a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-3 gap-3">
              {stats.map((stat) => (
                <div key={stat.label} className="p-5 rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md">
                  <div className="font-display text-2xl sm:text-3xl font-medium text-animax-yellow">
                    {stat.value}
                  </div>
                  <div className="mt-2 text-xs text-white/60 leading-snug">{stat.label}</div>
                </div>
              ))}
            </div>
            <div className="mt-4 p-5 rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md flex gap-4">
              <div className="w-11 h-11 rounded-xl bg-animax-yellow/20 flex items-center justify-center shrink-0">
                <Shield className="w-5 h-5 text-animax-yellow" />
              </div>
              <div>
                <div className="font-display text-lg font-medium">UV Protection</div>
                <p className="mt-1 text-sm text-white/60 leading-relaxed">
                  Dirancang untuk membantu menjaga kejernihan dan tampilan material saat dipakai
                  pada aplikasi indoor maupun outdoor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
